import { Box, SxProps, Theme } from '@mui/material';

type Props = {
  children?: React.ReactNode;
  currentTab: string;
  value: string;
  maxHeight?: number;
  sx?: SxProps<Theme>;
  keepMounted?: boolean;
};

const TabPanel = ({ children, currentTab, value, maxHeight, sx, keepMounted }: Props) => {
  const isSelected = value === currentTab;

  return (
    <Box
      role="tabpanel"
      hidden={!isSelected && !keepMounted}
      id={value}
      sx={{
        height: maxHeight ?? '100%',
        maxHeight: maxHeight,
        display: isSelected ? 'flex' : keepMounted ? 'none' : 'none', // 'none' when hidden
        flexDirection: 'column',
        flexGrow: 1,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {(isSelected || keepMounted) && <Box sx={{ display: isSelected ? 'contents' : 'none' }}>{children}</Box>}
    </Box>
  );
};

export default TabPanel;
